import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CheckoutRoutingModule } from './checkout-routing.module';
import { ShippingComponent } from './shipping/shipping.component';
import { AddressComponent } from './address/address.component';
import { ReviewComponent } from './review/review.component';
import { DoneComponent } from './done/done.component';
import { SharedModule } from '../shared/shared.module';
import { ShippingAddressComponent } from './review/shipping-address/shipping-address.component';
import { OrderItemsComponent } from './review/order-items/order-items.component';


@NgModule({
  declarations: [
    ShippingComponent,
    AddressComponent,
    ReviewComponent,
    DoneComponent,
    ShippingAddressComponent,
    OrderItemsComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CheckoutRoutingModule,
    SharedModule,
  ]
})
export class CheckoutModule { }
